import script from "./DirectMessageEntry.vue?vue&type=script&setup=true&lang=js"
export * from "./DirectMessageEntry.vue?vue&type=script&setup=true&lang=js"

import "./DirectMessageEntry.vue?vue&type=style&index=0&id=2503805e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2503805e"]])

export default __exports__